import React from 'react';
import SelectField from './../Form/SelectField';

const FormP18T4 = React.memo((props) => {
    const handleNotesChanges = (event) => {
        props.setNotes(event.target.value);
    };

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: 1, label: '1 pad (50 sheets per pad)' },
                    { value: 2, label: '2 pads (50 sheets per pad)' },
                    { value: 3, label: '3 pads (50 sheets per pad)' },
                    { value: 4, label: '4 pads (50 sheets per pad)' },
                    { value: 5, label: '5 pads (50 sheets per pad)' },
                    { value: 6, label: '6 pads (50 sheets per pad)' },
                    { value: 7, label: '7 pads (50 sheets per pad)' },
                    { value: 8, label: '8 pads (50 sheets per pad)' },
                    { value: 9, label: '9 pads (50 sheets per pad)' },
                    { value: 10, label: '10 pads (50 sheets per pad)' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Newborn Hearing Screening (NBHS) Results Card</div>
                <div className="description mt-3">
                    <span className="label">Description:</span> This tear-off notepad is for newborn hearing screening results utilized by staff
                    at UT Physicians Otorhinolaryngology - Texas Medical Center. The notepad is also conveniently sized to fit in the pockets of
                    standard white coats.
                </div>
                <div className="description-list">
                    <span className="label">Detail:</span>
                    <ul>
                        <li>Size: 5.5x4"</li>
                        <li>Color: One color, black ink</li>
                        <li>Paper: 60# Offset</li>
                        <li>One-sided</li>
                        <li>50 sheets per pad with glue and cardboard backing</li>
                    </ul>
                </div>
            </div>
            <div className="notes-container">
                <b>Notes:</b>
                <textarea value={props.notes} onChange={handleNotesChanges} />
            </div>
        </form>
    );
});

export default FormP18T4;
